import AjaxClass from './Validation/ajaxClass';

export default function bootstrapForms() {

    document.querySelectorAll('form.needs-validation').forEach(formElement => {
        
        // Seleção dos elementos dentro DESTE formulário específico
        const inputs = formElement.querySelectorAll('input:not([type="checkbox"]), textarea');
        const checkbox = formElement.querySelector('#confirme');

        // --- 1. SUAS FUNÇÕES ORIGINAIS ---
        
        function validarCampo(campo) {
            const valor = campo.value.trim();
            const id = campo.id;

            switch (id) {
                case 'nome':
                    return valor.length >= 3;
                case 'email':
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(valor);
                case 'telefone':
                    const numeros = valor.replace(/\D/g, '');
                    return numeros.length >= 10 && numeros.length <= 11;
                case 'mensagem':
                    return valor.length >= 10;
                default:
                    return valor.length > 0;
            }
        }

        function aplicarValidacao(campo, valido) {
            campo.classList.remove('valid', 'invalid');
            campo.classList.add(valido ? 'valid' : 'invalid');
        }

        // --- 2. SEUS EVENTOS EM TEMPO REAL ---

        inputs.forEach(campo => {
            campo.addEventListener('blur', function () {
                const valido = validarCampo(this);
                aplicarValidacao(this, valido);
            });

            campo.addEventListener('input', function () {
                if (this.classList.contains('invalid')) {
                    const valido = validarCampo(this);
                    aplicarValidacao(this, valido);
                }
            });
        });

        if (checkbox) {
            checkbox.addEventListener('change', function () {
                this.style.borderColor = !this.checked ? '#dc3545' : '';
            });
        }

        // --- 3. EVENTO DE SUBMIT ADAPTADO ---

        formElement.addEventListener('submit', function (e) {
            e.preventDefault(); // Impede o redirecionamento (a action)
            e.stopPropagation();

            let formValido = true;

            // Valida todos os campos
            inputs.forEach(campo => {
                const valido = validarCampo(campo);
                aplicarValidacao(campo, valido);
                if (!valido) formValido = false;
            });

            // Valida checkbox
            if (checkbox && !checkbox.checked) {
                checkbox.style.borderColor = '#dc3545';
                formValido = false;
                alert('⚠️ Você precisa concordar com a Política de Privacidade.');
                return false;
            }

            if (!formValido) {
                alert('❌ Por favor, preencha todos os campos corretamente.');
                return false;
            }

            // --- SE CHEGOU AQUI, ESTÁ TUDO VÁLIDO. INICIA O AJAX ---

            // DataLayer
            if (window.dataLayer && Array.isArray(window.dataLayer)) {
                const formName = formElement.getAttribute('data-name')?.trim() || formElement.id || 'Formulário';
                dataLayer.push({ event: 'formSubmit', formName: formName });
            }

            const Loader = document.getElementById("loading-forms");
            if (Loader) Loader.classList.add("open-modal");

            let form = this;
            let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));
            form.disabled = true;
            const sanitizeInput = (str) => {
                if (typeof str !== 'string') return str;
                return str.replace(/<[^>]*>?/gm, ''); // Remove qualquer tag HTML
            };
            let formData = new FormData(form);

            // Adiciona imagens se houver
            let images = form.querySelectorAll('input[type=file]');
            if (images.length > 0) {
                images.forEach(input => {
                    if (input.files[0]) formData.append(input.name, input.files[0]);
                });
            }

            fields.forEach(obj => {
                if (obj.value && typeof obj.value === 'string') {
                    obj.value = sanitizeInput(obj.value);
                }
                formData.append(obj.name, obj.value);
            });

            // Classe para tratar a resposta da AjaxClass
            const FormAjax = class extends AjaxClass {
                successFunction(data, form) {
                    if (Loader) Loader.classList.remove("open-modal");
                    form.disabled = false;
                    
                    if (data.status === true) {
                        form.reset();
                        // Limpa os estilos visuais
                        form.querySelectorAll('.valid, .invalid').forEach(el => el.classList.remove('valid', 'invalid'));
                        
                        if (data.redirect) {
                            window.location = data.redirect;
                        } else {
                            const modalSuccess = document.getElementById('success-message-forms');
                            if (modalSuccess) {
                                modalSuccess.classList.add("open-modal");
                                modalSuccess.querySelector('.description').innerHTML = data.txt;
                            }
                        }
                    } else {
                        const modalError = document.getElementById('error-message-forms');
                        if (modalError) {
                            modalError.classList.add("open-modal");
                            modalError.querySelector('.description').innerHTML = data.txt;
                        }
                    }
                }
                errorFunction() {
                    if (Loader) Loader.classList.remove("open-modal");
                    form.disabled = false;
                    alert("Ocorreu um erro técnico.");
                }
            };

            let ajax = new FormAjax(form, 'POST', form.action, 'json', formData);
            ajax.send();

            return false;
        });
    });
    
    document.querySelectorAll('[phone]').forEach(phoneElement => {
        phoneElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
    
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode) || (charCode === 190 && !this.value.includes('.'))) {
                return;
            }
    
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        phoneElement.addEventListener('blur', function () {
            mascaraDeTelefone(this);
        });
    
        phoneElement.addEventListener('focus', function () {
            tiraHifen(this);
        });
    });
    
    function mascaraDeTelefone(telefone) {
        const textoAtual = telefone.value.replace(/[^0-9]/g, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
    
        if (isCelular) {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 7);
            const parte3 = textoAtual.slice(7, 11);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        } else {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 6);
            const parte3 = textoAtual.slice(6, 10);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        }
    
        telefone.value = textoAjustado || null;
    }
    
    function tiraHifen(telefone) {
        telefone.value = telefone.value.replace(/\./g, '');
    }
    
    document.querySelectorAll('[cnpj]').forEach(cnpjElement => {
        cnpjElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cnpjElement.addEventListener('blur', function () {
            aplicarMascaraCNPJ(this);
        });
    
        cnpjElement.addEventListener('focus', function () {
            removerMascaraCNPJ(this);
        });
    });
    
    function aplicarMascaraCNPJ(cnpj) {
        const textoAtual = cnpj.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 2);
        const parte2 = textoAtual.slice(2, 5);
        const parte3 = textoAtual.slice(5, 8);
        const parte4 = textoAtual.slice(8, 12);
        const parte5 = textoAtual.slice(12, 14);
        
        cnpj.value = `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`; 
    }
    
    function removerMascaraCNPJ(cnpj) {
        cnpj.value = cnpj.value.replace(/[^0-9]/g, '');
    }

    document.querySelectorAll('[cpf]').forEach(cpfElement => {
        cpfElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            // Bloquear qualquer caractere que não seja número
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });

        cpfElement.addEventListener('blur', function () {
            aplicarMascaraCPF(this);
        });

        cpfElement.addEventListener('focus', function () {
            removerMascaraCPF(this);
        });
    });

    function aplicarMascaraCPF(cpf) {
        const textoAtual = cpf.value.replace(/[^0-9]/g, '');

        const parte1 = textoAtual.slice(0, 3);
        const parte2 = textoAtual.slice(3, 6);
        const parte3 = textoAtual.slice(6, 9);
        const parte4 = textoAtual.slice(9, 11);

        // Formato: 000.000.000-00
        cpf.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '-' + parte4 : ''}`;
    }

    function removerMascaraCPF(cpf) {
        cpf.value = cpf.value.replace(/[^0-9]/g, '');
    }


    document.querySelectorAll('[cep]').forEach(cepElement => {
        cepElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            // Permite teclas como backspace, delete, tab, enter e setas
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            // Restringe entrada apenas a números
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cepElement.addEventListener('blur', function () {
            aplicarMascaraCEP(this);
        });
    
        cepElement.addEventListener('focus', function () {
            removerMascaraCEP(this);
        });
    });
    
    function aplicarMascaraCEP(cep) {
        const textoAtual = cep.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 5);
        const parte2 = textoAtual.slice(5, 8);
        
        cep.value = `${parte1}-${parte2}`;
    }
    
    function removerMascaraCEP(cep) {
        cep.value = cep.value.replace(/[^0-9]/g, '');
    }
    
    document.querySelectorAll('[documento]').forEach(docElement => {
        docElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            // Bloquear qualquer caractere que não seja número
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });

        docElement.addEventListener('blur', function () {
            aplicarMascaraDocumento(this);
        });

        docElement.addEventListener('focus', function () {
            removerMascaraDocumento(this);
        });
    });

    function aplicarMascaraDocumento(el) {
        const texto = el.value.replace(/\D/g, '');

        if (texto.length <= 11) {
            // CPF: 000.000.000-00
            const parte1 = texto.slice(0, 3);
            const parte2 = texto.slice(3, 6);
            const parte3 = texto.slice(6, 9);
            const parte4 = texto.slice(9, 11);
            el.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '-' + parte4 : ''}`;
        } else {
            // CNPJ: 00.000.000/0000-00
            const parte1 = texto.slice(0, 2);
            const parte2 = texto.slice(2, 5);
            const parte3 = texto.slice(5, 8);
            const parte4 = texto.slice(8, 12);
            const parte5 = texto.slice(12, 14);
            el.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '/' + parte4 : ''}${parte5 ? '-' + parte5 : ''}`;
        }
    }

    function removerMascaraDocumento(el) {
        el.value = el.value.replace(/\D/g, '');
    }

}